export default function HeaderSpace(){
    return(
        <div style={{height: "50px"}}>
        </div>
    )
}